import { createFileRoute } from '@tanstack/react-router';
import { AutomationTestsRouteView } from '@/pages/workspaces/automations/[campaignId]/tests/routing';
import { CampaignExperimentsRoute } from './-route-wrappers';

function CampaignTestsRoute() {
  const { campaignId } = Route.useParams();
  return (
    <AutomationTestsRouteView
      campaignId={campaignId}
      experiments={<CampaignExperimentsRoute campaignId={campaignId} campaignPath="automations" />}
    />
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/automations/$campaignId/overview/tests/')(
  {
    component: CampaignTestsRoute,
  },
);
